import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListItem, MatListItemIcon, MatNavList } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { oofTourConfig } from '@vectronic/oof/shared/util';
import { LoggedInUserService } from '@vectronic/shared/data-access/logged-in-user';
import { HeaderComponent, ReportIssueComponent, TourGuideService } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';
import { environment } from '../environments/environment';
import { AboutMyVectronicComponent } from './about-my-vectronic/about-my-vectronic.component';

type NavItem = {
  label: string;
  path: string;
  icon: string;
  iconClass?: string;
  shouldDisplay: boolean;
  isActive: (url: string, route: string) => boolean;
};

@Component({
  selector: 'my-vectronic-root',
  imports: [
    HeaderComponent,
    RouterLink,
    MatIconModule,
    RouterOutlet,
    MatMenuModule,
    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,
    MatNavList,
    MatListItem,
    MatListItemIcon,
  ],
  templateUrl: './app.component.html',
  styles: [
    `
      mat-sidenav-container {
        flex-grow: 1;
      }
      mat-sidenav {
        width: fit-content;
      }
      main {
        height: 100%;
        overflow: auto;
      }
    `,
  ],
})
export class AppComponent {
  loggedInUserService = inject(LoggedInUserService);
  isNotProductionEnvironment = environment.environment !== 'production';
  env = environment;
  private router = inject(Router);
  private dialogService = inject(DialogService);
  private tourGuideService = inject(TourGuideService);

  navItems: NavItem[] = [
    {
      label: 'Orders',
      path: '/orders',
      icon: 'package_2',
      iconClass: 'material-symbols-outlined',
      shouldDisplay: true,
      isActive: (url: string, route: string) =>
        url.startsWith(route) && !url.endsWith('/complete-order-form'),
    },
    {
      label: 'Airtimes',
      path: '/airtimes',
      icon: 'satellite',
      shouldDisplay: true,
      isActive: (url: string, route: string) => url.startsWith(route),
    },
    {
      label: 'RMA',
      path: '/rma',
      icon: 'assignment_return',
      iconClass: 'material-symbols-outlined',
      shouldDisplay: true,
      isActive: (url: string, route: string) => url.startsWith(route),
    },
    {
      label: 'Complete Order Form',
      path: '/orders/complete-order-form',
      icon: 'playlist_add_check',
      shouldDisplay: this.loggedInUserService.isAdmin(),
      isActive: (url: string, route: string) => url === route,
    },
  ];

  onLogoutBtnClicked() {
    this.loggedInUserService.logout$.next();
  }

  openInNewTab(url: string) {
    window.open(url, '_blank');
  }
  openAboutMyVectronicModal() {
    this.dialogService.open(AboutMyVectronicComponent);
  }
  isActive(navItem: NavItem): boolean {
    return navItem.isActive(this.router.url, navItem.path);
  }
  reportIssueModal() {
    this.dialogService.open(ReportIssueComponent, {
      data: { applicationDescription: `My Vectronic` },
      config: {
        width: '52rem',
        position: { top: '15dvh' },
        maxHeight: '70dvh',
      },
    });
  }

  tourGuide() {
    this.tourGuideService.createTour(oofTourConfig, 'oof', null);
    this.tourGuideService.startTour();
  }
}
